// Mirrors the share-test-reviews variant but kept local so this feature doesn't cross-import that one.
export const ORANGE_OUTLINE_PILL_BUTTON_CLASS =
    "!rounded-pill !bg-white !border-p6-orange !text-p6-orange hover:!bg-p6-orange-light-pastel";

// Hover deliberately mirrors the teacher-side vocab card treatment (classActivityColors
// buttonHover), not the forest-green-pastel hover of the SECONDARY color variant.
export const GREEN_OUTLINE_PILL_BUTTON_CLASS =
    "!rounded-pill !bg-white !border-forest-green-800 !text-forest-green-800 hover:!bg-forest-green-800/10";
